// Lead-source / attribution fields. These are captured from the campaign URL and
// submitted with the lead so every Netlify submission (and the notification
// email / CRM) knows where it came from. Note: Google's own tags already handle
// the online GA4 + Ads attribution via cookies — these fields exist to tag the
// actual LEAD record and to enable offline conversion import (that's what gclid
// is for). All names are rendered as hidden inputs unconditionally so Netlify
// registers every field at build time.
export const ATTRIBUTION_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "fbclid",
  "market",
]
// Session-scoped (not localStorage): attribution belongs to THIS visit, so a
// later organic return doesn't inherit an old campaign's tags.
const ATTRIBUTION_KEY = "faceinstitute:international-quote-attribution"

// Resolve attribution from the campaign URL, falling back to what we stored
// earlier this session so it survives a refresh or in-site navigation that drops
// the query string. URL params win (this visit's touch) and are re-persisted.
// SSR-guarded and never throws.
export const loadAttribution = () => {
  if (typeof window === "undefined") return {}
  let stored = {}
  try {
    const raw = window.sessionStorage.getItem(ATTRIBUTION_KEY)
    if (raw) stored = JSON.parse(raw) || {}
  } catch (e) {
    stored = {}
  }
  let fromUrl = {}
  try {
    const params = new URLSearchParams(window.location.search)
    ATTRIBUTION_FIELDS.forEach((f) => {
      const v = params.get(f)
      if (v) fromUrl[f] = v
    })
  } catch (e) {
    fromUrl = {}
  }
  const merged = { ...stored, ...fromUrl }
  if (Object.keys(fromUrl).length) {
    try {
      window.sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(merged))
    } catch (e) {
      /* storage disabled/full — ignore, non-critical */
    }
  }
  return merged
}
